<template>
  <v-app id="inspire">
    <v-main>
      <v-container
        class=""
        fluid
      >
      <v-row
          align="start"
          justify="center"         
        >
          <img width="200" src="@/assets/logo.png">
        </v-row>
      </v-container>
      <v-container
        class=""
        fluid
      >
        <v-row
          align="center"
          justify="center"
          v-if="!dataReady || noData"
        >
          <v-col
              cols="12"
              sm="8"
              md="4"              
            >

            <v-card   class="elevation-12">
              <v-toolbar
                color="error"
                dark
                flat
              >
                <v-toolbar-title>Please enter your login information</v-toolbar-title>
                <v-spacer></v-spacer>
              </v-toolbar>
              <v-card-text>
                <v-form>
                  <v-text-field
                    label="User email"
                    name="mail"                  
                    type="text" v-model="mail"                    
                  ></v-text-field>
                  <v-text-field
                    label="Locator"
                    name="locator"                    
                    type="text" v-model="locator"                    
                  ></v-text-field>
                  <span v-if="loginError!=''">{{loginError}}</span>
                  <span v-if="noData && dataReady">No data available for this brand id</span>                                
                </v-form>
              </v-card-text>
              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn color="error" v-on:click=login()>Login</v-btn>
              </v-card-actions>
            </v-card>


            <!-- <v-card   class="elevation-12 mt-4">
              <v-toolbar
                color="error"
                dark
                flat
              >
                <v-toolbar-title>Feedback Summary</v-toolbar-title>
                <v-spacer></v-spacer>
              </v-toolbar>
              <v-card-text>
                <v-form v-on:keyup.enter="fetchData()">
                  <v-text-field
                    label="Brand ID"
                    name="brandId"
                    prepend-icon="mdi-account"
                    type="text" v-model="brandId"                    
                  ></v-text-field>
                  
                  <span v-if="noData && dataReady">No data available for this brand id</span>             
                </v-form>
              </v-card-text>
              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn color="error" v-on:click=fetchData()>Login</v-btn>
              </v-card-actions>
            </v-card> -->
            
          </v-col>        
        </v-row>
<!--         <v-row>
          <v-col>
            <check-codes v-if="brandId=='bridal-bridal-bridal'"></check-codes>
          </v-col>
        </v-row> -->
        <v-row
          align="start"
          justify="center"
          v-if="availableBrands.length > 0 ">
          <v-col cols="2">
            <v-form >
                <v-select
                  :items="availableBrands"  
                  item-text="name"
                  item-value="id"
                  label="Select a brand"
                  v-model="brandId"
                  v-on:input="fetchData()"
                ></v-select>
              </v-form>
          </v-col>
        </v-row>
        <v-row
          align="start"
          justify="center"
          v-if="availableBrands.length > 0 && dataReady"
          >
          <v-col
          cols="8">
            <h4>Below you’ll find the results of the competitions and surveys held during the parade. You can
use the filters to view the results by type of visitor(s) and country(-ies).
By default the dress displayed is the one that received the most votes but, if you want to see
others, you can include the reference in the “Product” box.</h4>
          </v-col>          
        </v-row>
        <v-row
          align="start"
          justify="center"
          v-if="questions['crush'].length>0"           
        >
          <v-col
            cols="6"
            sm="8"
            md="8"           
          >  
          <crush :brandId="parseInt(brandId)" :questions="questions['crush']"></crush>          
          
          </v-col>
        </v-row>
        
         <v-row
          align="center"
          justify="center"
          v-if="questions['one_only'].length>0"           
        >
          <v-col
            cols="6"
            sm="8"
            md="8"           
          >            
          <one-and-only :brandId="parseInt(brandId)" :questions="questions['one_only']"></one-and-only>
          </v-col>
        </v-row>
        <v-row
        align="center"
        justify="center"
        v-if="questions['poll'].length>0"           
        >
          <v-col
            cols="6"
            sm="8"
            md="8"           
          >            
          <poll :brandId="parseInt(brandId)" :questions="questions['poll']"></poll>
          </v-col>
        </v-row>
      </v-container>
    </v-main>
  </v-app>
</template>

<script>
  import OneAndOnly from './components/OneAndOnly';
  import Crush from './components/Crush';
  import Poll from './components/Poll';
  import * as Api from './tools/api.js';
  import * as ApiCrush from './tools/apiCrush.js';
  import * as ApiOneAndOnly from './tools/apiOneAndOnly.js';
  import * as ApiPoll from './tools/apiPoll.js';
  import * as BrandDB from './tools/brandDB.js';
  // import * as ApiService from './tools/api.js';
  // import CheckCodes from './components/CheckCodes';
  
  export default {
    props: {
      source: String,            
    },
    components: {
        OneAndOnly, Crush, Poll
    },
    data(){
      return {
        brandId: '',
        mail: '',
        locator: '',
        questions: {
          one_only:[],
          crush:[],
          poll:[]
        },              
        activeProduct:0,
        noData: false,
        dataReady: false,
        brands: [],
        loginError: ''      
        
      }
    },
    methods:{
      async login(){
        let info = await  Api.userLogin(this.mail,this.locator)
        this.loginError = ''
        if (info.success){
          this.brands = await  Api.getBrands(info.exhibitorId,info.accessToken)  
        }else{
          this.loginError = info.errorMessage
        }
        
      },
      async fetchData(){      
        // FETCH CRUSH DATA    
        this.questions['crush']= []
        this.questions['one_only']= []
        this.questions['poll']= []
        
        console.log("Fetching info for ",this.brandId)
        this.questions['crush'] = await ApiCrush.fetchQuestionsByBrandId(this.brandId)
        // FETCH ONE AND ONLY
        this.questions['one_only'] = await ApiOneAndOnly.fetchQuestionsByBrandId(this.brandId)
        
        this.questions['poll'] = await ApiPoll.fetchQuestionsByBrandId(this.brandId)

        if (this.questions['crush'].length == 0 && this.questions['one_only'].length == 0 && this.questions['poll'].length == 0){
          this.noData = true
          this.dataReady = true
        }else{
          this.noData = false
          this.dataReady = true            
        }
      },
    },
    computed:{
      availableBrands(){
        if (this.brands.length == 0)
          return []
        else{
          //let brandIds = BrandDB.brands.map((b) => b.id)
          let brandIds = [648,536,137,130,135,125,621,66,486,81,496,3,600,598,136,479,601,91,131,474,473,466,202,591,475]
          return this.brands.filter((b) => brandIds.includes(b.id))
        }
      } 
    }
  }
</script>

<style scoped>
.v-application .error {
    background-color: #e53e3e !important;
    border-color: #e53e3e !important;
}
</style>
